/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The colour roles the playslip builder reads. A role left unset falls back to the SDK's
 * built-in value, so a theme may set only the roles a lottery cares about.
 * 
 * A game's own brand colour is not one of these — it stays on the game's branding. The bonus
 * ball colour is deliberately absent too: it is SDK-owned so that a line always reads as two
 * pools, whatever colour the game is drawn in.
 * @export
 * @interface PlayslipThemeColors
 */
export interface PlayslipThemeColors {
    /**
     * Borders and dividers.
     * @type {string}
     * @memberof PlayslipThemeColors
     */
    borderColor?: string;
    /**
     * Secondary text colour.
     * @type {string}
     * @memberof PlayslipThemeColors
     */
    fontColorSecondary?: string;
    /**
     * Primary text colour.
     * @type {string}
     * @memberof PlayslipThemeColors
     */
    fontColorPrimary?: string;
    /**
     * Tint a chosen option sits on, so selection reads without relying on the border alone.
     * @type {string}
     * @memberof PlayslipThemeColors
     */
    accentBackgroundColor?: string;
    /**
     * Fill for a chosen control a game supplies no colour for: a filled number, a switched-on
     * add-on, a picked bet type.
     * @type {string}
     * @memberof PlayslipThemeColors
     */
    accentColor?: string;
    /**
     * Label colour on the committing action in the playslip builder.
     * @type {string}
     * @memberof PlayslipThemeColors
     */
    ctaFontColor?: string;
    /**
     * Fill behind the committing action in the playslip builder.
     * @type {string}
     * @memberof PlayslipThemeColors
     */
    ctaColor?: string;
}

/**
 * Check if a given object implements the PlayslipThemeColors interface.
 */
export function instanceOfPlayslipThemeColors(value: object): value is PlayslipThemeColors {
    return true;
}

export function PlayslipThemeColorsFromJSON(json: any): PlayslipThemeColors {
    return PlayslipThemeColorsFromJSONTyped(json, false);
}

export function PlayslipThemeColorsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlayslipThemeColors {
    if (json == null) {
        return json;
    }
    return {
        
        'borderColor': json['borderColor'] == null ? undefined : json['borderColor'],
        'fontColorSecondary': json['fontColorSecondary'] == null ? undefined : json['fontColorSecondary'],
        'fontColorPrimary': json['fontColorPrimary'] == null ? undefined : json['fontColorPrimary'],
        'accentBackgroundColor': json['accentBackgroundColor'] == null ? undefined : json['accentBackgroundColor'],
        'accentColor': json['accentColor'] == null ? undefined : json['accentColor'],
        'ctaFontColor': json['ctaFontColor'] == null ? undefined : json['ctaFontColor'],
        'ctaColor': json['ctaColor'] == null ? undefined : json['ctaColor'],
    };
}

export function PlayslipThemeColorsToJSON(value?: PlayslipThemeColors | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'borderColor': value['borderColor'],
        'fontColorSecondary': value['fontColorSecondary'],
        'fontColorPrimary': value['fontColorPrimary'],
        'accentBackgroundColor': value['accentBackgroundColor'],
        'accentColor': value['accentColor'],
        'ctaFontColor': value['ctaFontColor'],
        'ctaColor': value['ctaColor'],
    };
}

